<template>
<div class="lightbox">
  <div class="message shadow animate__animated animate__fadeInUp">
    <h1 class="mb-15" style="font-weight:normal;">{{ title }}</h1>
    <p> {{ body }}</p>
    <button class="mt-30 width-100" @click="$emit('close')">
      stäng
    </button>
  </div>
</div>
</template>

<script>
export default {
  name: 'message',
  props: {
    title: String,
    body: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .message {
    background-color: white;
    padding: 25px;
    width: 100%;
    margin-left: 15px;
    margin-right: 15px;
  }
  p {
    text-align: left;
  }
  .lightbox {
    z-index: 10000;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    justify-content: center;
    right: 0;
    background-color: rgba(0,0,0,.3);
    display: flex;
    align-items: center;
    text-align: center;
  }
</style>
